var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BehaviorSubject } from 'rxjs';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { DwUserService } from '../auth/user.service';
import { DwUserStorage } from '../auth/user-storage';
import { DwIamUserRepository } from './repository/iam-user-repository';
import { DwSystemConfigService } from '../config/config.service';
var DwIamUserService = /** @class */ (function (_super) {
    __extends(DwIamUserService, _super);
    function DwIamUserService(userStorage, iamUserRepository, configService) {
        var _this = _super.call(this, userStorage) || this;
        _this.userStorage = userStorage;
        _this.iamUserRepository = iamUserRepository;
        _this.configService = configService;
        _this.configService.get('iamUrl').subscribe(function (url) { return _this.iamUrl = url; });
        return _this;
    }
    /**
     * 取得使用者資訊
     * return 返回Observable
     */
    DwIamUserService.prototype.read = function (userId) {
        var _this = this;
        var subject = new BehaviorSubject(null);
        // const subject: Subject<any> = new Subject(); // 訂閱時, 還未被 new 出來.
        var info = {
            success: true,
            description: '',
            userInfo: null // 取得的回傳值.
        };
        this.iamUserRepository.getUserInfo(userId).subscribe(function (userDatas) {
            if (userDatas['message'] !== undefined && userDatas['message']) {
                info.success = false;
                info.description = userDatas['message'];
                subject.next(info);
                // subject.complete();  // 統一交由下方的return 把值回寫
                return;
            }
            info.userInfo = userDatas;
            _this.setUserInfo(userDatas);
            subject.next(info);
        });
        return subject.asObservable().pipe(filter(function (obsData) { return obsData !== null; }), // 不廣播初始值
        distinctUntilChanged() // 有改變時才廣播
        );
    };
    return DwIamUserService;
}(DwUserService));
export { DwIamUserService };
